export const nameTableColumn = {
  columnSerialNumber: 'columnSerialNumber',
  tariffBoolean: 'tariffBoolean',
  columnTariff: 'columnTariff',
  columnMeterReading: 'columnMeterReading',
  columnDate: 'columnDate',
  columnsAddressStart: 'columnsAddressStart',
  columnsAddressEnd: 'columnsAddressEnd',
  columnsAddress: 'columnsAddress',
  serviceCompanyId: 'serviceCompanyId',
  MeterTriffs_One: 'MeterTriffs_One',
  MeterTriffs_Two: 'MeterTriffs_Two',
};

export const nameTableRows = {
  firstRow: 'firstRow',
  headerRow: 'headerRow',
};
